<template>
  <div class="showModel">
    <pageTitle v-if="showTitle" class="getHeader" :title="title"></pageTitle>
    <!--    <div class="noShowAttach" v-if="isJs">
          <div class="certificate js jsBackground">
            <div class="top-title">
              <p class="sub-title">合格证编号：{{ showObj.shortPrintCode }}</p>
            </div>
            <h1>食用农产品合格证</h1>
            <div class="tips">
              <p class="tips-title">我承诺:</p>
              <div class="tips-content">
                <p>没有使用禁用农药兽药、停用兽药和非法添加物</p>
                <p>上市农产品符合农药安全间隔期、兽药休药期规定</p>
                <p>对食用农产品合格证的真实性负责</p>
              </div>
            </div>
            <div class="line"></div>
            <div class="list">
              <p class="item">
                <span class="span1">产品名称:</span>
                <span class="span2">{{ showObj.productName }}</span>
              </p>
              <p class="item">
                <span class="span1">数量(重量):</span>
                <span class="span2">{{ showObj.num }} {{ showObj.unitName }}</span>
              </p>
              <p class="item">
                <span class="span1">产地:</span>
                <span class="span2">{{ showObj.address }}</span>
              </p>
              <p class="item">
                <span class="span1">生产者:</span>
                <span class="span2">{{ showObj.entName }}</span>
              </p>
              <p class="item">
                <span class="span1">联系方式:</span>
                <span class="span2">{{ showObj.contactPhone }}</span>
              </p>
              <p class="item">
                <span class="span1">打印日期:</span>
                <span class="span2">{{ showObj.issueTimeStr }}</span>
              </p>
            </div>
            &lt;!&ndash;
            <div class="signBox" v-if="showSign">
              <img :src="showObj.signature">
            </div>
            &ndash;&gt;
          </div>
        </div>-->
    <div class="showAttach">
      <van-tabs class="tabs" v-model="active" swipeable background="#33bd7d" color="#beef7e"
                title-inactive-color="#fff" title-active-color="#beef7e" sticky animated
                title-style="height:50px;" @rendered="rendered">
        <van-tab title="电子合格证">
          <div class="certificate sx defaultBackground">
            <div class="top-title">
              <p class="sub-title">合格证编号：{{ showObj.shortPrintCode }}</p>
            </div>
            <h1>承诺达标合格证</h1>
            <div class="tips">
              <p class="tips-title">我承诺对生产销售的食用农产品:</p>
              <div class="tips-content">
                <p class="active">不使用禁用农药兽药、停用兽药和非法添加物</p>
                <p class="active">常规农药兽药残留不超标</p>
                <p class="active">对承诺的真实性负责</p>
              </div>
              <p class="tips-title">承诺依据:</p>
              <div class="tips-content pro">
                <p :class="[checkType!==1 && checkType>-1 && 'active blueText']" @click="switchTo(1)">委托检测</p>
                <p :class="[checkType===1 && checkType>-1 && 'active blueText']" @click="switchTo(2)">自我检测</p>
                <p :class="[produce===1 && produce>-1 && 'active blueText']">内部质量控制</p>
                <p class="active blueText">自我承诺</p>
              </div>
            </div>
            <div class="line"></div>
            <div class="list">
              <div class="pannel">
                <p class="item product">
                  <span class="span1 large">产品名称:</span>
                  <span class="span2">{{ showObj.productName }}</span>
                </p>
                <p class="item num">
                  <span class="span1 large-more">数量(重量):</span>
                  <span class="span2">{{ showObj.num }} {{ showObj.unitName }}</span>
                </p>
              </div>
              <p class="item">
                <span class="span1">产地:</span>
                <span class="span2">{{ showObj.address }}</span>
              </p>
              <!--     2022/5/25 山东显示生产企业         -->
              <p class="item" v-if="printAreaCode==='37'">
                <span class="span1">生产企业:</span>
                <span class="span2">{{ showObj.entName }}</span>
              </p>
              <p class="item imgBox">
                <span class="span1">生产者盖章或签名:</span>
                <span class="span2"><img v-if="showSign" :src="showObj.signature"></span>
              </p>
              <p class="item">
                <span class="span1 large">联系方式:</span>
                <span class="span2">{{ showObj.contactPhone }}</span>
              </p>
              <p class="item">
                <span class="span1 large">开具日期:</span>
                <span class="span2">{{ showObj.createTime }}</span>
              </p>
              <!-- 河北沧州 加这个 20210628 09:06-->
              <!--              <p class="item" v-if="showObj.workerName && printAreaCode === '13'">
                              <span class="span1">收购来源:</span>
                              <span class="span2">{{ showObj.workerName }}</span>
                            </p>-->
            </div>
          </div>
          <div class="examineRecord" v-if="isShowExamine">
            <button class="jump" @click="examineTo">
              <span>合格证查验</span>
              <van-icon name="coupon-o"/>
            </button>
          </div>
        </van-tab>
        <van-tab title="企业展示">
          <div class="showItem">
            <div class="tips-title">
              <span>主体信息</span>
              <span>以下信息由主体提供</span>
            </div>
            <div class="info">
              <span>主体名称</span>
              <span>{{ showObj.entName }}</span>
            </div>
            <div class="info">
              <span>主体类别</span>
              <span>{{ showObj.entClassifyName }}</span>
            </div>
            <div class="info">
              <span>所属行业</span>
              <span>{{ showObj.industryNames }}</span>
            </div>
            <div class="info">
              <span>联系人员</span>
              <span>{{ showObj.contactPerson }}</span>
            </div>
            <div class="info">
              <span>联系方式</span>
              <span><a :href="'tel:'+showObj.contactPhone">{{ showObj.contactPhone }}</a></span>
            </div>
            <div class="info">
              <span>联系地址</span>
              <span>{{ showObj.address }}</span>
            </div>
            <div class="info hasCredit" v-if="showObj.creditLevelName">
              <span>信用等级</span>
              <span>{{ showObj.creditLevelName }}</span>
            </div>
          </div>
          <div class="showItem">
            <div
                style=" margin-bottom:2vw; height: 10vw;line-height: 10vw; font-family:Arial,Helvetica,sans-serif;border-bottom: 1px solid #f1f1f1;">
              <span style="">资质认证</span>
            </div>
            <div>
              <van-grid v-if="showObj.qualificateList&&showObj.qualificateList.length>0" square :column-num="2">
                <van-grid-item v-for="(item,index) in showObj.qualificateList" :key="index">
                  <div
                      style="height:100%;display: flex;flex-direction: column;align-items: center;justify-content: space-between">
                    <span style="font-size: 12px;font-weight: bold">{{ item.tag }}</span>
                    <van-image
                        width="40%"
                        fit="scale-down"
                        :src="filterImg(item.tag)">
                    </van-image>
                    <span style="font-weight:bold;text-align: center;
                       width:10%;font-size: 12px;padding: 5px 10px;background: #2AB774;color: white;border-radius: 5px">{{
                        item.count
                      }}</span>
                  </div>
                </van-grid-item>
              </van-grid>
              <p v-else style="color:#ccc;text-align: center">无</p>
            </div>

          </div>
          <div class="showItem" v-if="isHasShopAuth">
            <div class="tips-title">
              <span>农产品商城</span>
              <span>以下信息由主体提供</span>
            </div>
            <div class="showMap">
              <button class="jump" @click="showShop">
                <span>去购买</span>
                <span class="iconfont icon-shop"></span>
              </button>
            </div>
          </div>
          <div class="showItem">
            <div class="tips-title">
              <span>产地地图</span>
              <span>以下信息由主体提供</span>
            </div>
            <div class="showMap" @touchMove.stop>
              <MapPoint :pointName="showObj.entName" :lat="showObj.lat" :lng="showObj.lng"/>
              <button class="jump" @click="jumpTo">
                <span>到这去</span>
                <span class="iconfont icon-daohang"></span>
              </button>
            </div>
          </div>
          <div class="showItem" v-if="showAttach">
            <div class="tips-title">
              <span>产地信息</span>
              <span>以下信息由主体提供</span>
            </div>
            <div class="showAttach">
              <img v-for="(v, i) in fileList" :key="'show'+i" :src="v.attachUrl">
            </div>
          </div>
        </van-tab>
        <van-tab title="追溯信息" v-if="isShowPaper">
          <div class="showItem" v-for="(v, i) in paperList" :key="'paperList'+i">
            <div class="tips-title">
              <span>追溯信息</span>
              <span>以下信息由国家平台及主体提供</span>
            </div>
            <div class="table-list" @click="showPaper(v.extUrl)">
              <div class="table-item">
                <p class="info">
                  <span>创建人</span>
                  <span>{{ v.createrName }}</span>
                </p>
                <p class="info">
                  <span>创建时间</span>
                  <span>{{ v.createTime }}</span>
                </p>
                <p class="info">
                  <span>产品名称</span>
                  <span>{{ v.productName }}</span>
                </p>
                <p class="info">
                  <span>产品重量</span>
                  <span>{{ v.sourceOneWeightStr }}</span>
                </p>
                <p class="info">
                  <span>所属地区</span>
                  <span>{{ v.areaPath }}</span>
                </p>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="生产信息">
          <div class="showItem">
            <div class="tips-title">
              <span>生产信息</span>
              <span>以下信息由主体提供</span>
            </div>
            <div class="info">
              <span>产品种类</span>
              <span>{{ showObj.productClassName }}</span>
            </div>
            <div class="info">
              <span>产品名称</span>
              <span>{{ showObj.productName }}</span>
            </div>
            <div class="info">
              <span>产品数量</span>
              <span>{{ showObj.num }} {{ showObj.unitName }}</span>
            </div>
          </div>
          <div class="showItem" v-if="produceList.length > 0">
            <div class="tips-title">
              <span>生产过程</span>
              <span>以下信息由主体提供</span>
            </div>
            <div class="progress">
              <van-steps direction="vertical" :active="produceList.length" active-icon="passed">
                <van-step class="proItem" v-for="(p, n) in produceList" :key="'produceList_'+n">
                  <p class="title">
                    <span>{{ p.optName }}</span>
                    <span>{{ p.optTime }}</span>
                  </p>
                  <p class="audio-line" v-if="p.soundUrl">
                    <AudioWechat :showId="'audio_media_'+n" :src="p.soundUrl"/>
                  </p>
                  <div class="imgBox" v-if="p.image1 || p.image2 || p.image3">
                    <p v-if="p.image1" @click="previewImg(p.image1)"
                       :style="{background: `url(${p.image1}) center / cover no-repeat`}"></p>
                    <p v-if="p.image2" @click="previewImg(p.image2)"
                       :style="{background: `url(${p.image2}) center / cover no-repeat`}"></p>
                    <p v-if="p.image3" @click="previewImg(p.image3)"
                       :style="{background: `url(${p.image3}) center / cover no-repeat`}"></p>
                  </div>
                </van-step>
              </van-steps>
            </div>
          </div>
        </van-tab>
        <van-tab title="监管信息">
          <div class="showItem" v-for="(v, i) in patrolList" :key="'patrolList_'+i">
            <div class="tips-title">
              <span>监管记录</span>
              <span>以下信息由政府农业监管部门提供</span>
            </div>
            <div class="table-list">
              <div class="table-item">
                <p class="info">
                  <span>监管机构</span>
                  <span>{{ v.regName }}</span>
                </p>
                <p class="info">
                  <span>监管时间</span>
                  <span>{{ v.patrolTime }}</span>
                </p>
                <p class="info">
                  <span>监管人员</span>
                  <span>{{ v.persons }}</span>
                </p>
                <p class="info">
                  <span>监管内容</span>
                  <span>{{ v.contents }}</span>
                </p>
                <p class="info">
                  <span>检测结果</span>
                  <span :class="v.result | statusFilter">{{
                      v.result === 1 ? '合格' : v.result === 2 ? '基本合格' : '不合格'
                    }}</span>
                </p>
                <div class="imgBox" v-if="v.image1 || v.image2 || v.image3">
                  <p v-if="v.image1" @click="previewImg(v.image1)"
                     :style="{background: `url(${v.image1}) center / cover no-repeat`}"></p>
                  <p v-if="v.image2" @click="previewImg(v.image2)"
                     :style="{background: `url(${v.image2}) center / cover no-repeat`}"></p>
                  <p v-if="v.image3" @click="previewImg(v.image3)"
                     :style="{background: `url(${v.image3}) center / cover no-repeat`}"></p>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="检测信息">
          <div class="showItem" v-for="(v, i) in detectList" :key="'detectList'+i">
            <div class="tips-title">
              <span>检测记录</span>
              <span>以下信息由政府农业监管部门及主体提供</span>
            </div>
            <div class="table-list">
              <div class="table-item">
                <p class="info">
                  <span>检测机构</span>
                  <span>{{ v.checkOrgName }}</span>
                </p>
                <p class="info">
                  <span>检测时间</span>
                  <span>{{ v.checkTime }}</span>
                </p>
                <p class="info">
                  <span>检测类型</span>
                  <span>{{ v.checkTypeStr }}</span>
                </p>
                <p class="info">
                  <span>检测人员</span>
                  <span>{{ v.persons }}</span>
                </p>
                <p class="info">
                  <span>检测产品</span>
                  <span>{{ v.productName }}</span>
                </p>
                <p class="info">
                  <span>检测结果</span>
                  <span :class="v.result | statusFilter">{{
                      v.result === 1 ? '合格' : v.result === 2 ? '基本合格' : '不合格'
                    }}</span>
                </p>
                <p class="info" v-if="v.detectorInfo">
                  <span>检测值</span>
                  <span>{{ v.detectorInfo.checkValue }}</span>
                </p>
                <div class="imgBox" v-if="v.image1 || v.image2 || v.image3">
                  <p v-if="v.image1" @click="previewImg(v.image1)"
                     :style="{background: `url(${v.image1}) center / cover no-repeat`}"></p>
                  <p v-if="v.image2" @click="previewImg(v.image2)"
                     :style="{background: `url(${v.image2}) center / cover no-repeat`}"></p>
                  <p v-if="v.image3" @click="previewImg(v.image3)"
                     :style="{background: `url(${v.image3}) center / cover no-repeat`}"></p>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <!--    <van-dialog v-model="showBindCode">-->
    <!--      <div class="showBindCode">-->
    <!--        <input type="text" v-model="securityCode" placeholder="请输入验证码">-->
    <!--      </div>-->
    <!--    </van-dialog>-->
    <van-overlay :show="showBindCode">
      <div class="show_wrapper">
        <div class="banner">
          <img :src="banner" alt="banner">
        </div>
        <div class="showCode">
          <div class="active_toggle">
            <div class="active_item" :class="{'active': isActive===1}" @click="toggleActive(1)">
              合格证编码
            </div>
            <div class="active_item" :class="{'active': isActive===2}" @click="toggleActive(2)">
              合格证防伪码
            </div>
          </div>
          <div class="showBindCode">
            <input type="text" v-model="bindCode" disabled placeholder="合格证编码">
          </div>
          <div class="showBindCode" v-if="isActive===2">
            <input type="text" @keyup.enter="toSearchByBindCode" maxlength="5"
                   v-model="securityCode" placeholder="刮开涂层输入五位防伪码">
          </div>
          <div class="searchBtn">
            <button type="button" @click="toSearchByBindCode">查询</button>
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 图片预览 -->
    <van-popup class="showPicPop" v-model="imageShow" :lock-scroll="true"
               get-container="body" :lazy-render="false" :overlay="false">
      <van-image-preview class="fixImgBox" v-model="imageShow" :close-on-popstate="true"
                         :images="imageList"/>
    </van-popup>
  </div>
</template>

<script>
import {searchByPrintCode, searchByPrintCodeHTTPS, pageCertificatePaper} from '@/api/search';
import {searchByBindCode} from '@/api/app_bind_code';
import {pageCheck, pagePatrol} from '@/api/dictionary';
import {printAreaCode} from '@/utils/baseUrl';
import AudioWechat from '@/components/AudioWechat/AudioWechat';
import MapPoint from "@/components/MapPoint/MapPoint";

export default {
  name: "model",
  components: {AudioWechat, MapPoint},
  filters: {
    statusFilter(result) {
      const statusMap = {
        1: 'success',
        2: 'success',
        0: 'danger',
      }
      return statusMap[result];
    }
  },
  data() {
    return {
      printAreaCode: printAreaCode,
      active: 0,
      printCode: '',
      showObj: {},
      title: '电子合格证展示',
      hasPromise: false,
      showTitle: false,
      showSign: false,
      showAttach: false,
      isJs: false,
      fileList: [],
      bindCode: '',
      securityCode: '',
      showBindCode: false,
      produceList: [],
      imageShow: false,
      imageList: [],
      patrolList: [],
      detectList: [],
      banner: '',
      isActive: 1,
      searchFrom: '1',
      isHttps: false,
      paperList: [],
      isShowPaper: printAreaCode === '50',
      checkType: -1,
      isHasShopAuth: false,
      isShowExamine: false,
      produce: -1,
      ims: [
        {
          // 绿色食品认证
          name: "绿色",
          url: "https://file.snzfnm.com/lvsp.png"
        },
        {
          // 有机食品认证
          name: "有机",
          url: "https://file.snzfnm.com/yjsp.png"
        },
        {
          // 特质农品
          name: "特质",
          url: "https://file.snzfnm.com/tznp.png"
        },
        {
          // 良好规范认证
          name: "良好",
          url: "https://file.snzfnm.com/lhgf.png"
        },
        {
          // 区域公共品牌
          name: "区域",
          url: "https://file.snzfnm.com/qypp.png"
        },
        {
          // 名特优新
          name: "名特",
          url: "https://file.snzfnm.com/tznp.png"
        },
      ],
    }
  },
  created() {
    // 20200703 14:53 隐藏
    // 20200826 17:00 江苏电子合格证样式
    if (printAreaCode === '32') { // 江苏
      this.isJs = true;
      this.isHttps = true;
      // 江苏没有商城
      this.isHasShopAuth = false;
    } else {
      this.isHasShopAuth = true;
    }
    if (printAreaCode === '37') { // 山东
      this.hasPromise = true;
      this.isHttps = true;
      this.banner = 'https://shandong-img.snzfnm.com/bindCode_sd_jn_banner.png'
    } else if (printAreaCode === '50') {
      this.hasPromise = true;
      this.isHttps = true;
      this.banner = ' https://cq-img-hgz.snzfnm.com/bindCode_cq_banner.jpg'
    } else {
      this.hasPromise = false;
    }
    if (printAreaCode === '13') { // 河北 衡水
      this.banner = 'https://hs-hgz.snzfnm.com/bindCode_hb_hs_banner.jpg'
    }
    if (!this.$route.query.t) {
      this.showTitle = true;
    }


    let tempPrintCode = this.$route.query.c
    if (Array.isArray(tempPrintCode)){
      this.printCode = tempPrintCode[0] || '';
    } else {
      this.printCode = tempPrintCode || '';
    }

    this.bindCode = this.$route.query.b || '';
    this.searchFrom = this.$route.query.s || '1';


    // 衡水小程序多了个 ?c=
    if (printAreaCode === "13" && this.printCode.startsWith("?c=")) {
      this.printCode = this.printCode.substr(3, this.printCode.length);
    }

    if (this.printCode) { // 扫码查看
      this.toSearchByPrintCode();
    } else if (this.bindCode && (printAreaCode === '37' || printAreaCode === '61' || printAreaCode === '13' || printAreaCode === '50')) { // 绑码查看
      this.showBindCode = true;
    } else {
      this.$alertErr('编码不存在, 请重试！');
    }
  },
  mounted() {
  },
  methods: {
    filterImg(tag) {
      if (!tag) return
      for (let i = 0; i < this.ims.length; i++) {
        let obj = this.ims[i]
        if (tag.startsWith(obj.name)) {
          return obj.url
        }
      }
    },
    examineTo() { // 合格证查验
      this.$router.push({
        path: 'examine-detail',
        query: {
          certificateRecordId: this.showObj.certificateRecordId,
          printRecordId: this.showObj.printRecordId,
          examineProdName: this.showObj.productName,
          examineNum: this.showObj.num,
          unitName: this.showObj.unitName,
        }
      })
    },
    switchTo(type) {
      const checkType = this.checkType;
      if (type === 1) { // 委托检测
        if (checkType !== 1 && checkType > -1) {
          this.active = 5;
          this.getPageCheck();
        }
      } else if (type === 2) { // 自我检测
        if (checkType === 1 && checkType > -1) {
          this.active = 5;
          this.getPageCheck();
        }
      }
    },
    showPaper(url) {
      if (!this.isShowPaper || !url) return;
      this.$router.push({
        path: '/paper-show-link',
        query: {
          url
        }
      })
    },
    showShop() {
      if (this.showObj && this.showObj.mallUrl) {
        location.href = `${this.showObj.mallUrl}`;
      }
    },
    jumpTo() {
      let u = navigator.userAgent
      if (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) {
        let data = {
          fromLat: '',
          fromLng: '',
          toLat: this.showObj.lat,
          toLng: this.showObj.lng,
          fromAddress: "",
          toAddress: this.showObj.entName
        }
        /* eslint-disable no-undef */
        method.naviTo(JSON.stringify(data))
      }else {
        location.href = `http://api.map.baidu.com/marker?location=${this.showObj.lat || '39.915'},${this.showObj.lng || '116.404'}&coord_type=bd09ll&title=终点位置&content=${this.showObj.entName}&output=html&src=webapp.baidu.openAPIdemo`
      }
    },
    // jumpTo() {
    //   var u = navigator.userAgent
    //   if (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) {
    //     let data = {
    //       fromLat: this.curCenter.lat,
    //       fromLng: this.curCenter.lng,
    //       toLat: this.showObj.lat,
    //       toLng: this.showObj.lng,
    //       fromAddress: "",
    //       toAddress: this.showObj.entName
    //     }
    //     /* eslint-disable no-undef */
    //     method.naviTo(JSON.stringify(data))
    //   } else {
    //     location.href = `https://api.map.baidu.com/marker?location=${this.showObj.lat || '39.915'},${this.showObj.lng || '116.404'}&coord_type=bd09ll&title=终点位置&content=${this.showObj.entName}&output=html&src=webapp.baidu.openAPIdemo`
    //   }

    // },
    rendered(name, title) { // 渲染首次触发
      if (name === 3) { // 监管信息
        this.getPagePatrol();
      } else if (name === 4) { // 检测信息
        this.getPageCheck();
      }
    },
    getPageCertificatePaper() { // 监管信息
      let entId = this.showObj.entId || '';
      if (!entId) {
        this.$alertErr('未获取到企业ID，请刷新后再试！');
        return
      }
      pageCertificatePaper({
        entId: entId,
        pageNum: 1,
        pageSize: 50
      }).then(res => {
        if (res.state === 'Y') {
          this.paperList = res.rows;
        } else {
          this.$alertErr(res.msg);
        }
      }).catch(err => {
        this.$alertErr(err || '网络错误，请稍后再试！');
      })
    },
    getPagePatrol() { // 监管信息
      let entId = this.showObj.entId || '';
      if (!entId) {
        this.$alertErr('未获取到企业ID，请刷新后再试！');
        return
      }
      pagePatrol({
        entId: entId,
        pageNum: 1,
        pageSize: 50
      }).then(res => {
        if (res.state === 'Y') {
          this.patrolList = res.rows;
        } else {
          this.$alertErr(res.msg);
        }
      }).catch(err => {
        this.$alertErr(err || '网络错误，请稍后再试！');
      })
    },
    getPageCheck() { // 检测信息
      let entId = this.showObj.entId || '';
      if (!entId) {
        this.$alertErr('未获取到企业ID，请刷新后再试！');
        return
      }
      pageCheck({
        entId: entId,
        pageNum: 1,
        pageSize: 50
      }).then(res => {
        if (res.state === 'Y') {
          this.detectList = res.rows;
        } else {
          this.$alertErr(res.msg);
        }
      }).catch(err => {
        this.$alertErr(err || '网络错误，请稍后再试！');
      })
    },
    previewImg(url) { // 查看照片
      this.imageList = [url];
      this.imageShow = true;
    },
    toSearchByBindCode() { // 查看绑码
      if (this.isActive === 2) { // 防伪码
        if (!this.securityCode) {
          this.$alertErr('防伪码不存在！');
          return
        }
        if (!this.securityCode.trim() || this.securityCode.trim().length < 4) {
          this.$alertErr('防伪码错误！');
          return
        }
      }
      let searchObj = {
        bindCode: this.bindCode,
      }
      if (this.isActive === 1) { // 不要防伪码
        searchObj.checkSecurityCode = false;
      } else if (this.isActive === 2) { // 需要防伪码
        searchObj.checkSecurityCode = true;
        searchObj.securityCode = this.securityCode.trim();
      }
      searchByBindCode(searchObj).then(res => {
        if (res.state === 'Y') {
          this.showObj = res.data;
          this.checkType = res.data.check ? res.data.check.checkType : -1;
          let time = res.data.issueTimeStr && res.data.issueTimeStr.split(' ')[0].split('-') || '';
          res.data.createTime = time ? `${time[0]}年${time[1]}月${time[2]}日` : '';
          this.showSign = !!res.data.signature;
          if (res.data.attachments && res.data.attachments.length > 0) { // 有企业展示图
            this.fileList = res.data.attachments;
            this.showAttach = true;
          }
          this.showBindCode = false;

          if (res.data.areaCode.indexOf('6101') > -1) {
            this.isShowExamine = true;
          }

          printAreaCode === '50' && this.getPageCertificatePaper();
        } else {
          this.$alertErr(res.msg);
        }
      }).catch(err => {
        this.$alertErr(err || '网络错误，请稍后再试！');
      })
    },
    toggleActive(index) { // 切换
      this.isActive = index;
    },
    chooseWay(obj) {
      if (this.isHttps && !this.showTitle) {// 扫码查看电子合格证 - HTTPS
        return searchByPrintCodeHTTPS(obj)
      } else { // app内查看电子合格证
        return searchByPrintCode(obj)
      }
    },
    toSearchByPrintCode() { // 查看电子合格证
      this.chooseWay({
        searchFrom: this.searchFrom,
        printCode: this.printCode
      }).then(res => {
        console.log('res', res.data.check)
        if (res.state === 'Y') {
          this.showObj = res.data;
          //this.chckType = -1时 不选中 1时 自我检测 2，3时委托检测
          // ⬇ 如果 res.data.check 为空的时候 this.checkType = -1  如果 res.data.checkType == 1 this.checkType = 1 如果 res.data.checkType 等于2 或者 3的时候this.checkType = 2 如果以上都不是 为-1
          this.checkType = !res.data.check ? -1 : (res.data.check.checkType == 1 ? res.data.check.checkType : (res.data.check.checkType == 2 || res.data.check.checkType == 3 ? 2 : -1));
          this.produce = !res.data.produce ? -1 : 1;
          let time = res.data.issueTimeStr && res.data.issueTimeStr.split(' ')[0].split('-') || '';
          res.data.createTime = time ? `${time[0]}年${time[1]}月${time[2]}日` : '';
          this.showSign = !!res.data.signature;
          if (res.data.attachments && res.data.attachments.length > 0) { // 有企业展示图
            this.fileList = res.data.attachments;
            this.showAttach = true;
          }
          if (res.data.produce && res.data.produce.details.length > 0) {
            this.produceList = res.data.produce.details;
          }
          if (res.data.areaCode.indexOf('6101') > -1) {
            this.isShowExamine = true;
          }
          printAreaCode === '50' && this.getPageCertificatePaper();
        } else {
          this.$alertErr(res.msg);
        }
      }).catch(err => {
        this.$alertErr(err || '网络错误，请稍后再试！');
      })
    },
  },
}
</script>

<style lang="stylus" scoped>
.showModel {
  background: #f1f1f1;
  position: relative;
  height: 100%;

  .certificate {
    min-height: 145.8vw;
    overflow: hidden !important;
    color: #000;
    position: relative;

    &.jsBackground {
      background: url("https://jiangsu-img-hgz.snzfnm.com/js-qrcode-show-bg.png") center 25% / contain no-repeat;
    }

    &.defaultBackground {
      background: url("https://sd-aqs.snzfnm.com/sdQrcodeShowBg.png") center 0 / contain no-repeat;
    }

    &.hasTitle {
      margin-top: 40px;
    }

    .topHeight {
      position: absolute;
      top: 0;
    }

    h1 {
      margin-top: 10vw;
      font-size: 9.2vw;
      font-weight: 500;
      text-align: center;
    }

    h2 {
      margin-top: 1vw;
      font-size: 3.5vw;
      font-weight: 500;
      text-align: center;
    }

    .list {
      margin: 5vw 8vw 0 10vw;

      p {
        display: flex;
        margin-bottom: 3vw;
        font-size: 3.5vw;
        line-height: 5vw;

        .span1 {
          text-align: left;
          font-weight: 600;
          min-width: 10vw;
        }

        .span2 {
          margin: 0 3vw 0 2vw;
          text-align: center;
          font-weight: 600;
        }

        &.unit {
          .span2 {
            margin: 0 1vw 0 3vw;
          }

          .span3 {
            flex: 0 0 8vw;
            margin: 0 3vw 0 1vw;
            text-align: center;
            vertical-align: bottom;
          }
        }

        &.hook {
          margin-bottom: 4vw;

          .span1 {
            flex: 0 0 25vw;
          }

          .hook-group {
            border-bottom: 0;
            margin-right: 0;
            margin-left: 2vw;

            b {
              position: relative;
              padding-left: 3.5vw;
              float: left;
              width: 21vw;
              text-align: left;
              margin-bottom: 2vw;
              font-size: 3vw;
              overflow: hidden;

              &:nth-child(2n) {
                margin-left: 2vw;
              }

              &:before {
                content: '';
                height: 2.5vw;
                width: 2.5vw;
                position: absolute;
                left: 0;
                top: 0.7vw;
                border: 1px solid #333;
              }

              &.hook-item:before {
                content: '✔';
                font-size: 3vw;
                line-height: 2.5vw;
              }
            }
          }
        }
      }
    }

    .tips {
      margin: 0 9vw;

      .tips-title {
        font-size: 3.5vw;
        font-weight: 600;
        text-align: left;
      }

      .tips-content {
        text-align: left;
        margin-left: 2vw;

        p {
          margin-top: 1.5vw;
          font-weight: 600;
          font-size: 2.5vw;
          overflow: visible;
          text-overflow: clip;
          word-break: break-all;
          word-wrap: break-word;
          white-space: normal;
          position: relative;
          padding-left: 3.5vw;

          &:before {
            content: '';
            height: 2.5vw;
            width: 2.5vw;
            position: absolute;
            left: 0;
            top: 0.7vw;
            border: 1px solid #333;
          }

          &:after {
            content: '✔';
            font-size: 3vw;
            line-height: 2.5vw;
            position: absolute;
            left: 0.3vw;
            top: 0.8vw;
          }
        }
      }
    }

    .signBox {
      position: absolute;
      bottom: 15%;
      right: 0%;

      img {
        width: 32vw;
      }
    }
  }

  .js {
    //min-height: 160vw;

    .top-title {
      display: flex;
      height: 20vw;
      line-height 20vw;

      .sub-logo {
        flex: 0 0 20vw;
        margin-left: 2vw;
        text-align: center;

        img {
          width 15vw;
          vertical-align: middle;
        }
      }

      .sub-title {
        flex: 1;
        font-size: 4vw;
        font-weight: 600;
        padding: 0 5vw;
        text-align: right;
      }
    }

    h1 {
      margin-top: 0;
      font-size: 7vw;
      font-weight: 700;
      font-family: '微软雅黑';
    }

    .list {
      margin: 5vw 7vw 0 7vw;

      p {
        font-size: 3.8vw;
        margin-bottom: 2vw;
      }
    }

    .tips {
      margin: 3vw 0 0 2vw;

      .tips-title {
        font-size: 5vw;
        margin-bottom: 2vw;
      }

      .tips-content {
        margin-left: 0;

        p {
          font-size: 4.2vw;
          padding-left: 4vw;
          margin-left: 1vw;

          &:before, &:after {
            top: 1.6vw;
          }
        }
      }
    }

    .line {
      height: 1px;
      width: 94%;
      margin: 3vw auto;
      background: #333;
    }

    .signBox {
      bottom: 20%;
      display: flex;
      align-items: center;
      width: 45vw;

      p {
        font-size: 4vw;
        font-weight: 600;
      }
    }
  }

  .sx {
    //height: 160vw;

    &.defaultBackground {
      background: url("https://sd-aqs.snzfnm.com/sdQrcodeShowBg.png") center 0 / contain no-repeat;
    }

    .top-title {
      display: flex;
      height: 10vw;
      line-height 10vw;
      margin-top: 8vw;

      .sub-logo {
        flex: 0 0 20vw;
        margin-left: 2vw;
        text-align: center;

        img {
          width 15vw;
          vertical-align: middle;
        }
      }

      .sub-title {
        flex: 1;
        font-size: 4vw;
        font-weight: 600;
        padding: 0 9vw;
        text-align: right;
      }
    }

    h1 {
      margin-top: 0;
      font-size: 7vw;
      font-weight: 700;
      font-family: '微软雅黑';
    }

    .list {
      margin: 5vw 7vw 0 9vw;

      p {
        font-size: 3.8vw;
        margin-bottom: 3vw;
      }
    }

    .tips {
      margin: 2vw 0 0 10vw;

      .tips-title {
        margin-top: 4vw;
        font-size: 4.5vw;
        height: 6vw;
        line-height: 6vw;
        margin-bottom: 0;
      }

      .tips-content {
        margin-left: 0;

        p {
          font-size: 3.5vw;
          padding-left: 4vw;
          margin-left: 0;

          &:before, &:after {
            top: 1.2vw;
          }

          &:after {
            display: none;
          }

          &.blueText {
            color: #0f99ee;
            background: transparent;
            cursor: pointer;
          }

          &.active {
            &:after {
              display: inline-block;
              color: #ff0000;
            }
          }

        }

        &.pro {
          display: flex;
          flex-wrap: wrap;

          p {
            width: 58%;

            &:nth-child(2n) {
              width: 30%;
            }
          }
        }
      }
    }

    .line {
      height: 1px;
      width: 85%;
      margin: 6vw auto 3vw auto;
      background-image: linear-gradient(to right, #333 0%, #333 60%, transparent 20%);
      background-size: 10px 1px;
      background-repeat: repeat-x;
    }

    .list {
      margin: 5vw 7vw 0 10vw;

      .pannel {
        display: flex;

        .item {
          flex: 1;
        }

        .product {
          flex: 0 0 48vw;
        }
      }

      .item {
        .large {
          flex: 0 0 16vw;
        }

        .large-more {
          flex: 0 0 18vw;
        }

        span {
          font-size: 3.2vw;
          font-weight: 500;
          position: relative;
          display: inline-block;
        }

        .span2 {
          margin: 0;
        }

        &.imgBox {
          overflow: visible;
          margin: 5vw 0;

          .span2 {
            width: 50%;
            overflow: visible;

            img {
              position: absolute;
              left: 0;
              top: -4vw;
              height: 12vw;
              width: auto;
              margin-left: 10vw;
            }
          }
        }
      }
    }

    .signBox {
      bottom: 17%;
      right: 0;
      display: flex;
      align-items: center;
      width: 45vw;

      p {
        font-size: 4vw;
        font-weight: 600;
      }
    }
  }
}

.showAttach {
  width: 100%;

  img {
    width: 100%;
  }
}

.showItem {
  margin: 3vw;
  padding: 0 4vw 4vw 4vw;
  background: #fff;
  border-radius: 2vw;
  position: relative;

  .info {
    display: flex;
    min-height: 8vw;

    span {
      overflow: visible;
      text-overflow: clip;
      word-break: break-all;
      word-wrap: break-word;
      white-space: normal;

      &:first-child {
        flex: 0 0 20vw;
        font-size: 4vw;
      }

      &:last-child {
        font-weight: 600;
        flex: 1;
        font-size: 4vw;
        color: #333;
      }

      a {
        vertical-align: middle;
        color: #33bd7d;
      }
    }
  }

  .hasCredit {
    position: absolute;
    right: 4vw;
    top: 20vw;
    height: 20vw;
    width: 20vw;
    line-height: 5vw;
    text-align: center;
    border-radius: 50%;
    border: 4px solid #33bd7d;
    display: block;

    span {
      display: block;
      color: #33bd7d;
      font-size: 4vw;
      font-weight: 600;

      &:first-child {
        margin-top: 5vw;
      }

      &:last-child {
        margin-top: 1vw;
        color: #33bd7d !important;
      }
    }
  }
}

.tips-title {
  height: 10vw;
  line-height: 10vw;
  overflow: hidden;
  display: flex;
  border-bottom: 1px solid #f1f1f1;
  margin-bottom 2vw;

  span {
    font-weight: 600;

    &:first-child {
      flex: 0 0 25vw;
      font-size: 4.5vw;
    }

    &:last-child {
      flex: 1;
      font-size: 3.5vw;
      text-align: right;
      color: #33bd7d;
    }
  }
}

.progress {
  .title {
    height: 5vw;
    line-height: 5vw;
    overflow: hidden;
    margin-bottom: 2vw;
    display: flex;

    span {
      font-size: 4vw;

      &:first-child {
        flex: 1;
        font-weight: 600;
      }

      &:last-child {
        flex: 0 0 120px;
        text-align: right;
      }
    }
  }

  .imgBox {
    margin-top: 2vw;
    display: flex;
    height: 50vw;

    p {
      flex: 1;
      margin: 0 2vw;
    }
  }
}

.van-steps--vertical {
  padding-left: 5vw;
}

.van-step--vertical {
  padding: 4vw 0;
}

.showPicPop {
  height: 101%;
  width: 101%;
  max-height: 101%;
  background-color: rgba(0, 0, 0, .88);

  /deep/ .van-image-preview__overlay {
    background: transparent;
  }
}

.table-list {
  .table-item {
    span {
      &.success {
        color: #33bd7d;
      }

      &.danger {
        color: #e34545;
      }
    }

    .imgBox {
      margin-top: 2vw;
      display: flex;
      height: 50vw;

      p {
        flex: 1;
        margin: 0 2vw;

        img {
          width: 100%;
        }
      }
    }
  }
}

.showMap, .examineRecord {
  .jump {
    width: 100%;
    margin: 2vw 0;
    outline: none;
    height: 12vw;
    line-height: 12vw;
    padding: 0;
    background: #33bd7d;
    color: #fff;
    border: 0;
    border-radius: 2vw;
    overflow: hidden;
    box-shadow: 0 0 2px #f1f1f1;
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      margin: 0 1vw;

      &:first-child {
        font-size: 4.5vw;
        font-weight: 600;
        letter-spacing: .5vw;
      }

      &:last-child {
        font-size: 5vw;
      }
    }

    i {
      margin: 0 1vw;
      font-size: 6vw;
      vertical-align: middle;
    }
  }
}


.showBindCode {
  width: 100%;
  margin: 8vw 0;

  input {
    display: block;
    height: 16vw;
    width: 80%;
    margin: 0 auto;
    padding: 0 5%;
    border: 1px solid #eee;
    border-radius: 5px;
    font-size: 4vmin;
  }
}

.show_wrapper {
  height: 100%;
  background: #fff;

  .banner {
    height: 47vw;
    overflow: hidden;

    img {
      width: 100vw;
    }
  }

  .showCode {
    padding: 10vw 4vw;

    .active_toggle {
      display: flex;

      .active_item {
        background: #f1f1f1;
        color: #666;
        padding: 4vw 0;
        font-size: 4.5vw;
        border-radius: 2vw;
        width: 40vw;
        text-align: center;
        margin: 0 5vw;
        font-weight: 600;
        border: 0;
        box-shadow: 0 0 4px #999;

        &.active {
          box-shadow: 0 0 4px #666;
          background: #33bd7d;
          color: #fff;
        }
      }
    }

    .searchBtn {
      width: 85vw;
      margin: 5vw auto;

      button {
        width: 100%;
        padding: 4vw 0;
        border-radius: 2vw;
        font-size: 4.5vw;
        font-weight: 600;
        border: 0;
        box-shadow: 0 0 5px #999;
        background: #33bd7d;
        color: #fff;
      }
    }
  }
}

.tabs {
  /deep/ .van-tabs__wrap {
    height: 10vw;

    .van-tab {
      font-size: 3.5vw;
    }

    .van-tabs__content {
      overflow: hidden;

      .van-tab__pane {
        height: 100%;
        overflow: hidden;
      }
    }
  }
}


</style>
